import { render, staticRenderFns } from "./ManuscriptSelectContent.vue?vue&type=template&id=5bf407ba&scoped=true"
import script from "./ManuscriptSelectContent.vue?vue&type=script&lang=ts"
export * from "./ManuscriptSelectContent.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptSelectContent.vue?vue&type=style&index=0&id=5bf407ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf407ba",
  null
  
)

export default component.exports